import { getRuntimeLocale } from "~/i18n/index";
import { resolveRequestLang } from "~/utils/request-lang";

type MasterSLocale = "zh-TW" | "en";

const ZH_TW_MESSAGES: Record<string, string> = {
	聊天记录: "聊天記錄",
	立即聊天: "立即聊天",
	"全球首创 AI 智慧伙伴MasterS": "全球首創 AI 智慧夥伴MasterS",
	挥手: "揮手",
	拥抱: "擁抱",
	比心: "比心",
	动作: "動作",
	"测算次数：": "測算次數：",
	充值: "充值",
	添加档案: "添加檔案",
	请添加档案: "請添加檔案",
	开心收下: "開心收下",
	"赠送：": "贈送：",
	次测算: "次測算",
	常见问题: "常見問題",
	"还需要摇@num次": "還需要搖@num次",
	"我的生日@birthday性别@sex问题@question": "我的生日@birthday性別@sex問題@question",
	删除聊天记录: "刪除聊天記錄",
	"确定删除@time聊天记录？删除后将不可恢复。": "確定刪除@time聊天記錄？刪除後將不可恢復。",
	"这里可以查看聊天记录哦～": "這裡可以查看聊天記錄哦～",
	请输入你的问题: "請輸入你的問題",
	添加: "添加",
	切换档案: "切換檔案",
	初爻: "初爻",
	二爻: "二爻",
	三爻: "三爻",
	四爻: "四爻",
	五爻: "五爻",
	上爻: "上爻",
	老阴: "老陰",
	少阳: "少陽",
	少阴: "少陰",
	老阳: "老陽",
	男: "男",
	女: "女",
	姓名: "姓名",
	确定: "確定",
	确认: "確認",
	查看结果: "查看結果",
	今日: "今日",
	一周: "一週",
	一月: "一月",
	全部: "全部",
	充值功能暂未开放: "充值功能暫未開放",
	"下单失败，请稍后重试": "下單失敗，請稍後重試",
	下单失败: "下單失敗",
	请先选择测算模型: "請先選擇測算模型",
	请先登录: "請先登錄，請通過 App 打開或傳入 uid 參數",
	"加载中...": "加載中...",
	暂无数据: "暫無數據",
	"请选择第@n张牌": "請選擇第@n張牌",
	点击摇卦: "點擊搖卦",
	"全球首创 AI 智慧伙伴": "全球首創 AI 智慧夥伴",
	"融合先知命局智慧与现代AI技术，陪你探索命运，解锁人生更多可能。":
		"融合先知命局智慧與現代AI技術，陪你探索命運，解鎖人生更多可能。",
	小提示: "小提示",
	"你可以向MasterS提问关于人生、性格、事业、感情等任何你想了解的问题。":
		"你可以向MasterS提問關於人生、性格、事業、感情等任何你想了解的問題。",
	"与MasterS 聊天": "與MasterS 聊天",
	"剩余次数:": "剩餘次數:",
	"你好，我能为您解答什么人生问题？": "你好，我能為您解答什麼人生問題？",
	请先选择上方测算模型: "請先選擇上方測算模型",
	首页: "首頁",
	首頁: "首頁",
	AI对话: "AI對話",
	AI對話: "AI對話",
	八字: "八字",
	塔罗: "塔羅",
	六爻: "六爻",
	聊天: "聊天",
	"MasterS@name测算 @count次": "MasterS@name測算 @count次",
	向左滚动: "向左滾動",
	向右滚动: "向右滾動",
};

const EN_MESSAGES: Record<string, string> = {
	聊天记录: "Chat History",
	立即聊天: "Chat Now",
	"全球首创 AI 智慧伙伴MasterS": "The world's first AI wisdom companion, MasterS",
	挥手: "Wave",
	拥抱: "Hug",
	比心: "Finger Heart",
	动作: "Action",
	"测算次数：": "Readings: ",
	充值: "Top Up",
	添加档案: "Add Profile",
	请添加档案: "Please add a profile",
	开心收下: "Accept",
	"赠送：": "Bonus: ",
	次测算: "readings",
	常见问题: "Common Questions",
	"还需要摇@num次": "@num more shakes needed",
	"我的生日@birthday性别@sex问题@question":
		"My birthday is @birthday, gender @sex. My question is: @question",
	删除聊天记录: "Delete Chat History",
	"确定删除@time聊天记录？删除后将不可恢复。":
		"Delete chat history from @time? This cannot be undone.",
	"这里可以查看聊天记录哦～": "You can view chat history here.",
	请输入你的问题: "Enter your question",
	添加: "Add",
	切换档案: "Switch Profile",
	初爻: "First Line",
	二爻: "Second Line",
	三爻: "Third Line",
	四爻: "Fourth Line",
	五爻: "Fifth Line",
	上爻: "Top Line",
	老阴: "Old Yin",
	少阳: "Young Yang",
	少阴: "Young Yin",
	老阳: "Old Yang",
	男: "Male",
	女: "Female",
	姓名: "Name",
	确定: "Confirm",
	确认: "Confirm",
	查看结果: "View Result",
	今日: "Today",
	一周: "One Week",
	一月: "One Month",
	全部: "All",
	充值功能暂未开放: "Top-up is not available yet",
	"下单失败，请稍后重试": "Order failed. Please try again later.",
	下单失败: "Order failed",
	请先选择测算模型: "Please select a reading model first",
	请先登录: "Please log in first. Open in the app or pass a uid parameter.",
	"加载中...": "Loading...",
	暂无数据: "No data",
	"请选择第@n张牌": "Please choose card @n",
	点击摇卦: "Tap to cast",
	"全球首创 AI 智慧伙伴": "The world's first AI wisdom companion",
	"融合先知命局智慧与现代AI技术，陪你探索命运，解锁人生更多可能。":
		"Blending destiny wisdom with modern AI to help you explore fate and unlock more possibilities.",
	小提示: "Tip",
	"你可以向MasterS提问关于人生、性格、事业、感情等任何你想了解的问题。":
		"Ask MasterS about life, personality, career, relationships, or anything else you want to understand.",
	"与MasterS 聊天": "Chat with MasterS",
	"剩余次数:": "Remaining: ",
	"你好，我能为您解答什么人生问题？": "Hello, what life question can I help you with?",
	请先选择上方测算模型: "Please select a reading model above",
	首页: "Home",
	首頁: "Home",
	AI对话: "AI Chat",
	AI對話: "AI Chat",
	八字: "Bazi",
	塔罗: "Tarot",
	六爻: "Liu Yao",
	聊天: "Chat",
	"MasterS@name测算 @count次": "MasterS @name reading @count",
	向左滚动: "Scroll left",
	向右滚动: "Scroll right",
};

const MESSAGES: Record<MasterSLocale, Record<string, string>> = {
	"zh-TW": ZH_TW_MESSAGES,
	en: EN_MESSAGES,
};

function normalizeLocale(locale?: string | null): MasterSLocale {
	return locale === "en" ? "en" : "zh-TW";
}

export function getMasterSLocale(): MasterSLocale {
	if (import.meta.client) {
		return normalizeLocale(getRuntimeLocale());
	}
	return "zh-TW";
}

export function getMasterSApiLang() {
	const path =
		import.meta.client && typeof window !== "undefined" ? window.location.pathname : undefined;
	return resolveRequestLang(path, { i18nLocale: getMasterSLocale() });
}

export function getMasterSWsLang() {
	return getMasterSApiLang();
}

export function t(key: string, params?: Record<string, string | number>): string {
	const locale = getMasterSLocale();
	let text = MESSAGES[locale][key] ?? ZH_TW_MESSAGES[key] ?? key;
	if (params) {
		for (const [k, v] of Object.entries(params)) {
			text = text.replace(`@${k}`, String(v));
		}
	}
	return text;
}

/** 与模型 type 一致：1 八字 / 2 塔罗 / 3 六爻 / 4 聊天（按 type 翻译，避免接口 name 语言不随切换更新） */
const MODEL_NAME_KEYS: Record<number, string> = {
	1: "八字",
	2: "塔罗",
	3: "六爻",
	4: "聊天",
};

export function tModelName(type: number, fallbackName?: string): string {
	const key = MODEL_NAME_KEYS[type] || (fallbackName || "").trim();
	return key ? t(key) : "";
}
